module.exports = __webpack_public_path__ + "img/gis-add-mapbox.7575be4d.svg";